import React, { useState, useEffect, useCallback } from 'react';
import { Button, Card, Modal, Transfer } from 'antd';

/**
 *
 * @param selectedApps {Array[String]} - The apps currently selected by the user for the page
 * @param allAvailableApps {Array[Object]} - The full list of apps available to the user
 * @param allowedApps {Array[String], Optional} - The list of apps that the user is allowed to select from
 * @param onUpdate {Function} - The function to call when the user updates their selected apps
 * @param onSuccessCallback {Function, Optional} - The function to call when the user successfully updates their apps
 * @returns {JSX.Element}
 * @constructor
 */
const AppSelector = ({
  selectedApps,
  allAvailableApps,
  allowedApps = [],
  onUpdate,
  onSuccessCallback
}) => {
  const [targetKeys, setTargetKeys] = useState([]);
  const [transferData, setTransferData] = useState([]);

  const handleUpdateUserApps = useCallback((updatedApps) => {
    if (onUpdate) {
      onUpdate(updatedApps);
    }
  }, [onUpdate]);

  useEffect(() => {
    const filteredApps = allAvailableApps
      .filter(app => allowedApps.length === 0 || allowedApps.includes(app.key))
      .map(app => ({
        key: app.key,
        title: app.label,
        description: app.label,
        iconUrl: app.iconUrl,
      }));
    setTransferData(filteredApps);
    setTargetKeys(selectedApps);
  }, [selectedApps, allowedApps, allAvailableApps]);

  const handleChange = (nextTargetKeys) => {
    setTargetKeys(nextTargetKeys);
  };

  const renderItem = (item) => ({
    label: (
      <div>
        <img src={item.iconUrl} alt={item.title} style={{ width: 24, marginRight: 8 }} />
        {item.title}
      </div>
    ),
    value: item.title,
  });

  const handleSubmit = () => {
    handleUpdateUserApps(targetKeys);
    if (onSuccessCallback) {
      onSuccessCallback();
    } else {
      Modal.info({
        title: 'Update Successful',
        content: `The user's apps have been updated.`,
      });
    }
  };

  return (
    <Card title="Manage User Applications">
      <Transfer
        dataSource={transferData}
        titles={['Available Apps', 'User Apps']}
        targetKeys={targetKeys}
        onChange={handleChange}
        render={renderItem}
        listStyle={{
          width: 250,
          height: 300,
        }}
        showSearch
      />
      <Button type="primary" onClick={handleSubmit} style={{ marginTop: 16 }}>
        Submit Changes
      </Button>
    </Card>
  );
};

export default AppSelector;
